import React, { useContext, useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import moment from "moment";

// d.ts
import { DCRecord, IDataController } from "@/@types/lib/dataController"

// Material UI Core
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Toolbar from "@mui/material/Toolbar";

// Material UI Icons
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";

// Custom Components
import FormButton from "@/ui/Form/FormButton";
import ModelTable from "@/ui/Table/ModelTable";
import TableButtonView from "@/ui/Table/ActionButtons/TableButtonView";
import TableButtonDelete from "@/ui/Table/ActionButtons/TableButtonDelete";
import DialogContext from "@/ui/DialogContext/DialogContext";
import LoaderContext from "@/components/LoaderContext/LoaderContext";
import ToolbarFillContent from "@/ui/Toolbar/ToolbarFillContent";
import StazaDialog from "@/views/GIS/StazePage/StazaDialog";

import model from "@/models/staze";
import dataController from "@/lib/dataController";
import { DialogContextType } from "@/@types/ui/DialogContext";
import TableHeaderButtonFilter from "@/ui/Table/HeaderButtons/TableHeaderButtonFilter";
import { FilterAltOff } from "@mui/icons-material";

import { LoaderContextType } from "@/@types/context/LoaderContext";


// TODO:
// subModels cleanup: they are added to the project because Table.jsx can not function without them
function ReportsStazeTable() {
  const dialogContext = useContext<DialogContextType>(DialogContext);
  const loaderContext = useContext(LoaderContext) as LoaderContextType;

  const { t } = useTranslation();

  const [records, setRecords] = useState<DCRecord[]>([]);

  const dc: IDataController = new dataController(model);

  useEffect(() => {
    refreshRecords();
  }, []);

  const handleView = (evt: React.SyntheticEvent, sel: string[]) => {
    const selId: number = parseInt(sel[0], 10);
    const record: DCRecord = records[selId];
    dialogContext.showDialog(StazaDialog, {
      dc: dc,
      mode: "view",
      form: "default",
      recordId: record.id,
      onClose: handleDialogClose
    });
  };

  const handleDialogClose = (result: { dataChanged: boolean; action: string }) => {
    if (result.dataChanged) {
      refreshRecords();
    }
  };

  const refreshRecords = () => {
    loaderContext.toggleLoading(true);
    dc.GetData().then((resp) => {
      if (resp.success) {
        if (Array.isArray(resp.data)) {
          setRecords(resp.data || []);
        }
        else {
          setRecords([]);
        }
      };
    }).finally(() => {
      loaderContext.toggleLoading(false);
    });
  };

  return (
    <ModelTable
      title={t("titles.staze")}
      viewName="report-markacije"
      records={records}
      dc={dc}
      allowSelection="one"
      allowFilter={true}
      allowExport={true}
      allowAdd={false}
      onRowAction={() => { }}
      allowRowAction={() => { return true; }}
    >
      <TableButtonView variant="contained" onClick={handleView} />
    </ModelTable>
  );
}

export default ReportsStazeTable;
